{
  "paymentMethod": {
    "BANK_CARD": "银行卡",
    "ALIPAY": "支付宝",
    "WECHAT": "微信"
  },
  "flatFee": "单笔 {{amount}}",
  "vipConditionsTitle": "VIP {{level}} 极速交易条件",
  "noVipPaymentMethods": "当前VIP等级暂无可用极速交易支付方式",
  "fee": "手续费 {{value}}",
  "availableRange": "可用范围 {{value}}",
  "checkout": "{{method}}支付",
  "close": "关闭",
  "checkoutLoading": "正在载入付款页面…",
  "checkoutLoadFailed": "付款页面暂时无法载入，请重试。",
  "retry": "重试",
  "checkoutHint": "请在此页面完成{{method}}支付，完成后会自动确认到账。",
  "openCheckout": "打开付款页面",
  "externalCheckoutHint": "请打开新窗口完成{{method}}支付，完成后会自动确认到账。您可以返回此处再次打开付款页面或选择其他方式。",
  "externalCheckoutUnavailableHint": "如果付款页面无法打开或载入，请返回此处选择其他付款方式。",
  "chooseOtherMethod": "选择其他付款方式",
  "chooseOtherMethodHint": "仅在尚未付款时选择其他方式。此订单会保留至到账或到期。"
}
